export default function getCroppedImg(imageSrc, pixelCrop, outputSize = null) {
    const image = new Image();

    image.src = imageSrc;

    return new Promise((resolve) => {
        image.onload = () => {
            const canvas = document.createElement("canvas");
            const outputWidth = outputSize?.width || pixelCrop.width;
            const outputHeight = outputSize?.height || pixelCrop.height;

            canvas.width = outputWidth;
            canvas.height = outputHeight;

            const ctx = canvas.getContext("2d");

            ctx.drawImage(
                image,
                pixelCrop.x,
                pixelCrop.y,
                pixelCrop.width,
                pixelCrop.height,
                0,
                0,
                outputWidth,
                outputHeight,
            );

            canvas.toBlob((blob) => {
                resolve(blob);
            }, "image/jpeg");
        };
    });
}